/* Denner home page: new-in tabs, sale countdown (UK time), sale auto-hide
   16 Oct 2026 (speed): the countdown only ticks every second while it is on screen; off screen it
   checks once a minute (so the sale still hides itself on time). */
(function(){
  if (window.__dennerHome) return; window.__dennerHome = true;
  function pad(n){ return String(n).padStart(2, '0'); }
  function init(){
    document.querySelectorAll('[data-dh-tabs]').forEach(function(root){
      if (root.__dh) return; root.__dh = true;
      var tabs = root.querySelectorAll('[role=tab]');
      var all = root.querySelector('[data-dh-all]');
      tabs.forEach(function(t){
        t.addEventListener('click', function(){
          tabs.forEach(function(u){
            var on = u === t;
            u.setAttribute('aria-selected', on);
            var p = document.getElementById(u.getAttribute('aria-controls'));
            if (p) p.hidden = !on;
          });
          if (all) { all.href = t.dataset.url; all.textContent = t.dataset.allLabel; }
        });
      });
    });
    document.querySelectorAll('[data-dh-sale]').forEach(function(sec){
      if (sec.__dh) return; sec.__dh = true;
      var end = Date.parse(sec.dataset.end);
      if (isNaN(end)) return;
      var cd = sec.querySelector('[data-dh-cd]');
      var els = cd ? { d: cd.querySelector('[data-d]'), h: cd.querySelector('[data-h]'), m: cd.querySelector('[data-m]'), s: cd.querySelector('[data-s]') } : null;
      var timer = null, visible = false, last = {};
      function set(el, k, v){ if (el && last[k] !== v) { el.textContent = v; last[k] = v; } }
      function tick(){
        var s = Math.floor((end - Date.now()) / 1000);
        if (s <= 0) {
          clearInterval(timer); timer = null;
          if (!sec.hasAttribute('data-design-mode')) sec.remove();
          return;
        }
        var lastDay = s < 86400;
        if (last.cls !== lastDay) { sec.classList.toggle('is-last', lastDay); last.cls = lastDay; }
        if (els && visible) {
          set(els.d, 'd', String(Math.floor(s / 86400)));
          set(els.h, 'h', pad(Math.floor(s % 86400 / 3600)));
          set(els.m, 'm', pad(Math.floor(s % 3600 / 60)));
          set(els.s, 's', pad(s % 60));
        }
      }
      function run(ms){ clearInterval(timer); timer = setInterval(tick, ms); }
      tick(); run(60000);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function(list){
          visible = list[0].isIntersecting;
          if (visible) { tick(); run(1000); } else { run(60000); }
        }, { rootMargin: '100px 0px' }).observe(sec);
      } else { visible = true; run(1000); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function(){ window.__dhInit = 0; init(); });
})();
